import styled from 'styled-components';

export const Container = styled.aside`
    display: flex;
    flex-wrap: wrap;
`;

export const Wrapper = styled.aside`
    flex: 0 0 calc(50% - 10px);
    margin: 5px;

    .feature-name {
        margin-left: 5px;
    }
`;
